var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 10.0667C24.8933 4.31667 20.8533 0 16 0C12.1467 0 8.8 2.73333 7.13333 6.73333C3.12 7.26667 0 11.5167 0 16.6667C0 22.1833 3.58667 26.6667 8 26.6667H25.3333C29.0133 26.6667 32 22.9333 32 18.3333C32 13.9333 29.2667 10.3667 25.8 10.0667ZM25.3333 23.3333H8C5.05333 23.3333 2.66667 20.35 2.66667 16.6667C2.66667 13.25 4.70667 10.4 7.41333 10.05L8.84 9.86667L9.50667 8.28333C10.7733 5.23333 13.2533 3.33333 16 3.33333C19.4933 3.33333 22.5067 6.43333 23.1867 10.7167L23.5867 13.2167L25.6267 13.4C27.7067 13.5667 29.3333 15.75 29.3333 18.3333C29.3333 21.0833 27.5333 23.3333 25.3333 23.3333ZM10.6667 15H14.0667V20H17.9333V15H21.3333L16 8.33333L10.6667 15Z",
    fill: "#3D96C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.a0cd5e78ce62c54dc9f39919740cfc5f.svg";
export { ForwardRef as ReactComponent };